import Swiper, { Navigation } from "swiper";

export default {
    init() {
        if (document.querySelector('.swiper-posts-people')) {
            Array.from(document.querySelectorAll('.swiper-posts-people'))
                .forEach(el => {
                    let numberOfSlides = Array.from(el.querySelectorAll('.swiper-slide')).length;

                    el.swiper = new Swiper(el, {
                        modules: [Navigation],
                        slidesPerView: 'auto',
                        loop: numberOfSlides > 4,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    });
                });
        }
    }
}
